<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0">
         <cus-form ref="form-compoundDrug" :columns="fromcolumnList" :data="compoundDrug.fromdata" @extrabutton-click="ExtraButtonClick" @confirm="savecompoundDrugIn">
    </cus-form>
    <ListView :columns="listcolumnList" :rowNoStyle="true" :datalist="compoundDrug.listdata"></ListView>
     <CloseButton ref="close-btn" type="confirm" @confirm="saveInfo" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: `CompoundDrugBody`,
    props: {
        visible: { type: Boolean, default: () => false }
        // data:{type:Object}
    },
    data() {
        return {
            title: `复合用药`,
            decimalPlaces: 3,
            surgeryId: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            drugtypes: this.$route.query.drugtypes.split(`,`) || [],
            usedrugid: this.$route.query.usedrugid || 0,
            token: this.$route.query.token,
            compoundDrugdata: {},
            Analgesicdetail: {
                dialogFormVisible: true
            },
            msg: `closeWindow`,
            compounddrug_search_result: [],
            compoundDrug: {
                fromdata: {
                    id: null,
                    dic_compound_drug_group_code: ``,
                    dic_compound_drug_group_name: ``,
                    group_type_id: null,
                    is_continue: false,
                    begin_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    end_time: null,
                    concentration: ``,
                    concentration_unit: ``,
                    unit: ``,
                    add_drug_way: ``,
                    dic_infusion_channel_id: null
                },
                listdata: []
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadDecimalPlaces()
        this.init()
        this.loadPermissions()
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_CURRENTUSER`)
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
        this.loadInfusionChannel()
        this.searchcompounddrug()
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`]),
        screenHeight2() {
            return this.screenHeight
        },
        drugtypeOption() {
            // console.log(999999999999, this.drugtypes)
            // debugger
            if (this.drugtypes && this.drugtypes.length > 0) {
                let oldtypes = _.cloneDeep(this[`drug/drug_type`] || [])
                if (oldtypes && oldtypes.length > 0) {
                    let r = _.map(this.drugtypes, d => {
                        let drugtype = _.filter(oldtypes, { value: parseInt(d) })
                        if (drugtype && drugtype.length > 0) {
                            return drugtype[0]
                        }
                    })
                    return r
                }
            }
        },
        fromcolumnList() {
            let that = this
            return [{
                type: `select`,
                prop: `dic_compound_drug_group_code`,
                label: `名称`,
                isCreatable: true,
                isEditable: true,
                options: this.compounddrug_search_result,
                change: (t, { row, area }) => {
                    that.compounddruguseDrug(row)
                },
                readonly: this.usedrugid > 0,
                colspan: 12,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `select`,
                prop: `group_type_id`,
                label: `使用类型`,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                colspan: 12,
                options: this.drugtypeOption,
                readonly: this.usedrugid > 0,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `select`,
                prop: `is_continue`,
                label: `是否连续`,
                width: `120`,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                options: `enum_bool`,
                colspan: 12,
                default: false,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `float`,
                prop: `total_dose`,
                label: `总剂量`,
                width: `60`,
                isCreatable: true,
                colspan: 6,
                isEditable: true,
                default: 0,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `select`,
                prop: `unit`,
                label: `单位`,
                width: `60`,
                isCreatable: true,
                colspan: 6,
                options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                    return {
                        value: d.label,
                        label: d.label
                    }
                }),
                isEditable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `float`,
                prop: `concentration`,
                label: `浓度`,
                isCreatable: true,
                isEditable: true,
                colspan: 12,
                decimal_places: this.decimalPlaces
            }, {
                type: `select`,
                prop: `concentration_unit`,
                label: `浓度单位`,
                isCreatable: true,
                isEditable: true,
                colspan: 12,
                options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                    return {
                        value: d.label,
                        label: d.label
                    }
                })
            }, {
                type: `select`,
                prop: `add_drug_way`,
                label: `途径`,
                config: {
                    'popper-append-to-body': true
                },
                isCreatable: true,
                isEditable: true,
                colspan: 12,
                options: _.map(this[`drug/drug_way`], d => {
                    return {
                        value: d.label,
                        label: d.label,
                        jianpin: d.jianpin
                    }
                })
            }, {
                type: `datetime`,
                prop: `begin_time`,
                label: `开始时间`,
                width: `160`,
                isCreatable: true,
                isEditable: true,
                colspan: 6,
                config: {
                    datetimeFormate: `yyyy/MM/dd HH:mm`,
                    noPadding: true,
                    editable: true
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `datetime`,
                prop: `end_time`,
                label: `结束时间`,
                width: `160`,
                isCreatable: true,
                isEditable: true,
                colspan: 6,
                config: {
                    datetimeFormate: `yyyy/MM/dd HH:mm`,
                    noPadding: true,
                    editable: true
                }
            }, {
                type: `select`,
                prop: `dic_infusion_channel_id`,
                label: `用药通道`,
                width: `100`,
                config: {
                    'popper-append-to-body': true
                },
                isListable: true,
                options: this.InfusionChannel
            }
            ]
        },
        listcolumnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    isKey: true,
                    label: `编号`
                },
                {
                    type: `string`,
                    prop: `dic_drug_name`,
                    label: `名称`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: true,
                    colspan: 12
                },
                {
                    type: `float`,
                    prop: `dose`,
                    label: `剂量`,
                    width: `60`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 6,
                    default: 0,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 6,
                    options: _.filter(this[`drug/drug_unit`], { isconcentration: false, isspeed: false, disabled: false }).map(d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    }),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }, {
                    type: `float`,
                    prop: `concentration`,
                    label: `浓度`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 12,
                    decimal_places: this.decimalPlaces
                }, {
                    type: `select`,
                    prop: `concentration_unit`,
                    label: `浓度单位`,
                    isCreatable: true,
                    isEditable: true,
                    isListable: true,
                    readonly: false,
                    colspan: 12,
                    options: _.filter(this[`drug/drug_unit`], { isconcentration: true, disabled: false }).map(d => {
                        return {
                            value: d.label,
                            label: d.label
                        }
                    })
                }
            ]
        }
    },
    methods: {
        loadDecimalPlaces() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ConcentrationDecimalPoint`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.decimalPlaces = parseInt(data.value)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadInfusionChannel() {
            let req = this.myaxios.get(`/api/AcisSystem/InfusionChannel/Get`)
            req.then(data => {
                this.InfusionChannel =
                    data &&
                    data.map(d => {
                        return {
                            value: d.id,
                            label: d.name
                        }
                    })
            }).catch(e => {
                console.log(e)
            })
        },
        init() {
            // 处理传过来的类型
            console.log(`usedrugid`, this.usedrugid)
            if (this.usedrugid > 0) {
                this.loadUseDrugDetail()
            }
        },
        loadUseDrugDetail() {
            let that = this
            let req = this.myaxios.get(`/api/Intraoperative/Anaesthesia/GetUseCompoundDrugByID?id=${this.usedrugid}`)
            req.then(data => {
                console.log(`usedrug`, data)
                that.compoundDrug.fromdata = data
                that.compoundDrug.listdata = data.usage_details
            })
        },
        saveInfo() {
            this.$refs[`form-compoundDrug`].confirm()
        },
        SaveAs(row) {
            this.saveOne()
        },
        confirm($that) {
            this.savecompoundDrugIn()
        },
        removeItem({ index }) {
            let row = this.mdata.record_templates.splice(index, 1)[0]
            if (row.id) {
                this.removeItems.push(row)
            }
        },
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        searchcompounddrug() {
            let req = this.myaxios.get(`/api/AcisSystem/CompoundDrug/Search`, { keyword: this.compounddrug_search_key })
            req.then(data => {
                this.compounddrug_search_result = _.filter(data, { disabled: false })
            }).catch(e => {
                this.compounddrug_search_result = []
            })
        },
        compounddruguseDrug(row) {
            let that = this
            console.log(row)
            let req = that.myaxios.get(`/api/AcisSystem/CompoundDrug/GetDrugByGroupCode?groupCode=${row.dic_compound_drug_group_code}`)
            req.then(data => {
                that.compoundDrug.fromdata.id = null
                let thisdrug = this.compounddrug_search_result.find(s => s.value == row.dic_compound_drug_group_code)
                that.compoundDrug.fromdata.dic_compound_drug_group_code = thisdrug.value
                that.compoundDrug.fromdata.dic_compound_drug_group_name = thisdrug.label
                let r = _.map(data, d => {
                    return {
                        id: d.id,
                        dic_drug_id: d.id,
                        dic_drug_name: d.name,
                        dic_drug_full_name: d.full_name,
                        dose: d.dose,
                        unit: d.drug_unit,
                        concentration: d.concentration,
                        concentration_unit: d.concentration_unit
                    }
                })
                that.compoundDrug.listdata = r
                console.log(11111, that.compoundDrug)
                // data.forEach(d => {
                //     that.utilityPromise = this.utilityPromise.then((g) => {
                //         console.log()
                //     })
                // })
            })
        },
        editcompounddrug({ index }) {
            let that = this
            let row = this.compoundDrugdata.record_templates[index]
            if (row.id) {
                that.compoundDrug.dialogFormVisible = true
                that.compoundDrug.fromdata = row
                that.compoundDrug.listdata = row.usage_details
            }
        },
        removecompounddrug({ index }) {
            let that = this
            let row = this.compoundDrugdata.record_templates[index]

            if (row.id) {
                this.$confirm(`是否确定删除?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`
                }).then(() => {
                    let req = this.myaxios.delete(`/api/Intraoperative/Anaesthesia/DeleteUseDrugById?id=${row.id}`)
                    req.then(data => {
                        winformMsg.acceptMessage({ action: `compounddrug`, data: { id: row.id, is_delete: true } })
                        that.init()
                    }).catch(e => {
                        console.log(e)
                    })
                })
            }
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
                console.log(e)
            })
        },
        savecompoundDrug(ddd) {
            this.$refs[`form-compoundDrug`].confirm()
        },
        savecompoundDrugIn(row) {
            let that = this
            console.log(that.compoundDrug)
            if (row.end_time != null && row.end_time != undefined) {
                if (row.end_time.indexOf(`/Date`) > -1) {
                    row.end_time = this.$moment(row.end_time).format(`YYYY/MM/DD HH:mm`)
                }
                if (row.begin_time.indexOf(`/Date`) > -1) {
                    row.begin_time = this.$moment(row.begin_time).format(`YYYY/MM/DD HH:mm`)
                }
                if (row.end_time < row.begin_time) {
                    this.$message.warning(`开始时间不允许大于结束时间！`)
                    return
                }
            }
            let fullname = ``
            console.log(`that.compoundDrug.listdata`)
            console.log(that.compoundDrug.listdata)
            let r = _.map(that.compoundDrug.listdata, d => {
                fullname += d.dic_drug_name + `(${d.dose}${d.unit})` + `+`
                return {
                    id: d.id,
                    dic_drug_id: d.dic_drug_id,
                    name: d.dic_drug_name,
                    dose: d.dose,
                    begin_time: row.begin_time,
                    end_time: row.end_time,
                    unit: d.unit,
                    concentration: d.concentration,
                    concentration_unit: d.concentration_unit
                }
            })
            console.log(r)
            if (fullname.length > 0) {
                fullname = fullname.slice(0, fullname.length - 1)
            }
            let usedrug = {
                id: row.id,
                biz_surgery_info_id: that.surgeryId,
                dic_drug_type_id: row.group_type_id,
                dic_drug_id: 0,
                total_dose: row.total_dose,
                unit: row.unit,
                enum_record_type: that.recordType,
                dic_compound_drug_group_code: row.dic_compound_drug_group_code,
                dic_compound_drug_group_name: fullname,
                group_type_id: row.group_type_id,
                is_continue: row.is_continue,
                begin_time: row.begin_time,
                end_time: row.end_time,
                concentration: row.concentration,
                concentration_unit: row.concentration_unit,
                add_drug_way: row.add_drug_way,
                dic_infusion_channel_id: row.dic_infusion_channel_id,
                usage_details: r
            }
            console.log(`usedrug`)
            console.log(usedrug)
            // this.myaxios[d.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${d.id > 0 ? `PutUseDrug` : `PostUseDrug`}`
            let req = this.myaxios[usedrug.id > 0 ? `put` : `post`](`/api/Intraoperative/Anaesthesia/${usedrug.id > 0 ? `PutUseDrug` : `PostUseDrug`}`, usedrug)
            req.then(data => {
                console.log(data)
                let r = typeof winformMsg
                if (r != `undefined`) {
                    winformMsg.acceptMessage({ action: `compounddrug`, data: { id: data.id, is_delete: false } })
                }
                this.$message.success(`保存成功`)
                this.$refs[`close-btn`].close()
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
    }
}
</script>
<style  lang="less" >
.usage-drug-event {
    .el-radio {
        width: 85px;
        margin: 5px 5px 0 0;
        overflow: hidden;
        .el-radio__input {
            display: none;
        }
        .el-radio__label {
            padding-left: 0;
            // display: block;
            white-space: nowrap;
            text-align: justify;
            text-align-last: justify;
            display: inline-block;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/CompoundDrugBody.vue